import React from "react";
import { HashRouter, Route, Switch } from "react-router-dom";
import App from "./pages/App";
import Download from "./pages/Download";
import Contact from "./pages/Contact";
import Equipment from "./pages/Equipment";
import News from "./pages/News";
import Yuyue from "./pages/Yuyue";
import my from "./pages/My";
import Expert from "./pages/Expert";

import EquipmentDetail from "./pages/EquipmentDetail";
import Introduce from "./pages/Introduce";
import IntroduceDetail from "./pages/IntroduceDetail";
import TechnicalService from "./pages/TechnicalService";
import Info from "./pages/Info";
import ReceivingInformation from "./pages/ReceivingInformation";
import ReceivingInformationEdit from "./pages/ReceivingInformationEdit";
import SampleDelivery from "./pages/SampleDelivery";
import Fp from "./pages/Fp";
import FpDetail from "./pages/FpDetail";
import test from "./pages/test";
import test_know from "./pages/test_know";
import testDetail from "./pages/testDetail";
import share from "./pages/share";
import ReceivingAdd from "./pages/ReceivingAdd";
import SeeOrder from "./pages/SeeOrder";
import SeeOrderV2 from "./pages/SeeOrderV2";
import AgainOrder from "./pages/AgainOrder";
import Culture from "./pages/Culture";
import Artisan from "./pages/Artisan";
import OrderList from "./pages/NOrderList";
import Cache from "./pages/Cache";
import FPAdd from "./pages/FPAdd";
import BigImg from "./pages/BigImg";
import Warn from "./pages/Warn";

// const BasicRouter = () =>

export default class extends React.Component {
  constructor(props) {
    super(props);
    // console.log("清除全部缓存");
    // localStorage.clear();
  }

  render() {
    return (
      <HashRouter>
        <Switch>
          <Route exact path="/" component={App} />
          <Route exact path="/download" component={Download} />
          <Route exact path="/contact" component={Contact} />
          <Route exact path="/equipment/:type" component={Equipment} />
          <Route exact path="/news" component={News} />
          <Route exact path="/yuyue/:id?" component={Yuyue} />
          <Route exact path="/my" component={my} />
          <Route
            exact
            path="/EquipmentDetail/:id"
            component={EquipmentDetail}
          />
          <Route exact path="/Introduce" component={Introduce} />
          <Route exact path="/IntroduceDetail" component={IntroduceDetail} />

          <Route exact path="/TechnicalService" component={TechnicalService} />
          <Route exact path="/Culture" component={Culture} />
          <Route exact path="/Artisan" component={Artisan} />


          <Route exact path="/info" component={Info} />
          <Route exact path="/fp/:model" component={Fp} />

          <Route exact path="/test" component={test} />
          <Route exact path="/test_know" component={test_know} />
          <Route exact path="/testDetail/:id" component={testDetail} />
          <Route exact path="/FpDetail/:id" component={FpDetail} />

          <Route exact path="/share" component={share} />
          <Route exact path="/receivingAdd" component={ReceivingAdd} />
          <Route exact path="/seeOrder/:id" component={SeeOrder} />
          <Route exact path="/seeOrderV2/:id" component={SeeOrderV2} />

          <Route exact path="/OrderList" component={OrderList} />
          <Route exact path="/Cache/:id" component={Cache} />
          <Route exact path="/AgainOrder/:id" component={AgainOrder} />
          <Route exact path="/FPAdd" component={FPAdd} />
          <Route exact path="/BigImg" component={BigImg} />
          <Route exact path="/Warn" component={Warn} />
          <Route exact path="/Expert" component={Expert} />

          <Route
            exact
            path="/receivingInformation/:model"
            component={ReceivingInformation}
          />
          <Route
            exact
            path="/ReceivingInformationEdit/:id"
            component={ReceivingInformationEdit}
          />

          <Route exact path="/sampleDelivery/:id" component={SampleDelivery} />
        </Switch>
      </HashRouter>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Router.js